module.exports = __webpack_public_path__ + "img/minor-prize.f06bb160.webp";